import { LatLngBounds } from 'leaflet';
import { SpeciesV2 } from '../interfaces';
import axios from 'axios';

// const BASE_URL = "process.env.REACT_APP_MINKA_URL"
const BASE_URL = "https://api.minka-sdg.org/v1";
// Documentaion: https://api.minka-sdg.org/v1/docs

export const checkApiHealthMinka = async () => {
  try {
    await axios.get(`${BASE_URL}`, {
      headers: {
        accept: 'application/json',
      },
    });
    return true;
  } catch (error) {
    return false;
  }
};

export const getPostMinkaSpeciesObservation = async (
  bounds: LatLngBounds,
  language: string,
): Promise<[SpeciesV2[], string | null]> => {
  const url = `${BASE_URL}/observations?nelat=${bounds.getNorth()}&nelng=${bounds.getEast()}&swlat=${bounds.getSouth()}&swlng=${bounds.getWest()}&order=desc&order_by=created_at&locale=${language}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const data = await response.json();

    const speciesList: SpeciesV2[] = data.results.map((species: any) => ({
      id: species.id,
      name: species.taxon?.iconic_taxon_name || species.iconic_taxon_name || undefined,
      author: species.user?.name || undefined,
      family: species.rank || undefined,
      commonNames: species.taxon?.preferred_common_name || undefined,
      predictedName: species.species_guess || undefined,
      images: species.photos?.map((image: any) => image.url) || [],
      taxaName: species.taxon?.name || undefined,
      taxaId: species.taxon?.id || undefined,
      taxaRank: species.taxon?.rank || undefined,
      taxaRankLevel: species.taxon?.rank_level || undefined,
      category: undefined,
      is_invasive: undefined,
      is_endemic: species.taxon?.endemic || undefined,
      is_eu_directive: undefined,
      is_grin_uses: undefined,
      iucn_red_list_category: species.taxon?.iucn_category || undefined,
      observed_data: species?.time_observed_at ? new Date(species.time_observed_at) : undefined,
      latitude: species?.location ? parseFloat(species.location.split(',')[0]?.trim()) || undefined : undefined,
      longitude: species?.location ? parseFloat(species.location.split(',')[1]?.trim()) || undefined : undefined,
    }));

    return [speciesList, null];
  } catch (error: any) {
    console.error('Error fetching observations:', error);
    const errorMessage = error.message || 'An unexpected error occurred while fetching observations.';
    return [[], errorMessage];
  }
};
